import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractControl, Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class BackgroundCloseControl extends AbstractControl implements Control {

    private sprite: PIXI.Sprite;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);
        this.sprite = layer.getSprite(assetNames[0]);
        this.sprite.interactive = true;

        this.sprite.on(ButtonEvent.CLICK.getPIXIEventString(), () => {
            this.smartUIGroup.hide();
        });
    }

    public destroy() {
        if (this.sprite) {
            this.sprite.destroy();
            this.sprite = null;
        }
    }
}
